module.exports = __webpack_public_path__ + "img/about1.bf9f808.png";